import { Avatar, Stack, Text } from "@mantine/core";
import IconUserFilled from "@src/assets/icons/tabler/user-filled.svg?react";
import { useTextOverflow } from "./hooks/use-text-overflow";
import { SharePanelTooltipWrapper } from "./share-panel-tooltip-wrapper";

export function ShareWhiteboardUserDisplay(props: {
	user: {
		name: string;
		email: string;
		avatarUrl: string;
	};
	isCurrentUser: boolean;
}) {
	const { user, isCurrentUser } = props;

	const { textRef: textNameRef, isOverflowing: isNameOverflowing } =
		useTextOverflow(user.name);

	const { textRef: textEmailRef, isOverflowing: isEmailOverflowing } =
		useTextOverflow(user.email);

	return (
		<>
			<Avatar
				radius="xl"
				bd="1px solid #0000001a"
				size="md"
				color="#86b2b5"
				src={user.avatarUrl}
			>
				<IconUserFilled width="1.5rem" height="1.5rem" />
			</Avatar>

			<Stack gap={0} align="stretch" className="flex-1 min-w-0" ml="xs" mr="xs">
				{user.name !== "" && (
					<SharePanelTooltipWrapper
						isOverflowing={isNameOverflowing}
						label={user.name}
					>
						<div className="flex items-center gap-1">
							<Text
								className="pointer-events-auto"
								fw={500}
								truncate="end"
								ref={textNameRef}
							>
								{user.name}
							</Text>

							{isCurrentUser && (
								<Text c="gray" fw={500}>
									(You)
								</Text>
							)}
						</div>
					</SharePanelTooltipWrapper>
				)}

				<SharePanelTooltipWrapper
					isOverflowing={isEmailOverflowing}
					label={user.email}
				>
					<Text
						className="pointer-events-auto"
						truncate="end"
						ref={textEmailRef}
					>
						{user.email}
					</Text>
				</SharePanelTooltipWrapper>
			</Stack>
		</>
	);
}
